/**
 * Maps API error description/status to a stable i18n key (no translation).
 * Parent does t('namespace:errors.' + getPythonErrorKey(error)) for the message.
 */
export interface PythonErrorLike {
	description?: string;
	status?: number;
}

export function getPythonErrorKey(error?: PythonErrorLike | null): string {
	const description = error?.description?.toLowerCase();
	if (!description) return 'uncaught';

	if (description.includes('invalid user')) return 'invalid';
	if (description.includes('subscription expired')) return 'expired';
	if (description.includes('login is inactive')) return 'inactive';
	if (description.includes('subscription cancelled')) return 'cancelled';
	if (description.includes('login with sso')) return 'sso';
	if (description.includes('too many requests') || error?.status === 429) return 'too_many_attempts';

	return 'uncaught';
}
